import { initHeroCarousels } from "./includes/hero-carousel.js";
import { buttonOptionSet, quantityField, btnDeleteAction } from "./includes/form.js";
import { cakePriceCalculator } from "./includes/cake-price.js";
import { mobileMenuToggle } from "./includes/header.js";
import { initAllCakesBlocks } from "./includes/all-cakes-block.js";
import { initKioskPage } from "./includes/kiosk.js";
import { initOrdersBoardPage } from "./includes/orders-board.js";

document.addEventListener("DOMContentLoaded", () => {
	initHeroCarousels();
	buttonOptionSet();
	cakePriceCalculator();
	quantityField();
	mobileMenuToggle();
	btnDeleteAction();
	initAllCakesBlocks();
	initKioskPage();
	initOrdersBoardPage();
});
